import React, { useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { Input } from '@app/components/common/inputs/Input/Input';
import { notificationController } from '@app/controllers/notificationController';
import { useResetFormOnCloseModal } from '@app/components/forms/ControlForm/useResetFormOnCloseModal';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { Upload } from '@app/components/common/Upload/Upload';
import { Button } from '@app/components/common/buttons/Button/Button';
import { UploadOutlined } from '@ant-design/icons';
import { doCreateForm } from '@app/store/slices/formSlice';
import { resizeThumbnail } from '@app/utils/utils';
import * as S from './CreateFormModal.styles';

interface CreateFormModalProps {
  open: boolean;
  onCancel: () => void;
  onFinish: () => void;
}
interface NewFormData {
  title: string;
  files: File[];
}

export const CreateFormModal: React.FC<CreateFormModalProps> = ({ open, onCancel, onFinish }) => {
  const [form] = BaseForm.useForm();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  useResetFormOnCloseModal({
    form,
    open,
  });

  const onOk = async () => {
    form.submit();
  };

  const onFormCancel = async () => {
    onCancel && onCancel();
  };

  const handleSubmit = (values: NewFormData) => {
    setLoading(true);
    const _thumbnailFile: File | any = values.files[0];
    // console.log(_file);

    const _params = {
      title: values.title,
      file: _thumbnailFile?.originFileObj ?? _thumbnailFile,
    };
    dispatch(doCreateForm(_params))
      .unwrap()
      .then((res) => {
        setLoading(false);
        if (res) {
          notificationController.success({
            message: 'Create new form',
            description: 'Successfully',
          });
          onFinish();
        } else {
          notificationController.error({
            message: 'Create new form',
            description: 'Failed',
          });
        }
      })
      .catch((err) => {
        // notificationController.error({ message: err.message });
        setLoading(false);
      });
  };

  const normFile = (e = { fileList: [] }) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const dummyRequest = async (options: { file: any; onSuccess?: any; onError?: any; onProgress?: any }) => {
    const { onSuccess, onError, file, onProgress } = options;

    // const fmData = new FormData();
    let _thumbnail = file;
    try {
      _thumbnail = await resizeThumbnail(file);
    } catch (error) {
      console.log('[resizeThumbnail] error:', error);
      // form.setFieldsValue({ files: [file] });
    }

    form.setFieldsValue({ files: [_thumbnail] });

    // console.log((fmData.get('file') as File).name);

    try {
      // const res = await axios.post(`${process.env.REACT_APP_BASE_URL}files/upload`, fmData, config);
      onSuccess('Ok');
      // form.setFieldsValue({ files: [fmData.get('file')] });
    } catch (err) {
      onError({ err });
    }
  };

  return (
    <Modal title="Create Form" open={open} onOk={onOk} onCancel={onFormCancel} confirmLoading={isLoading}>
      <BaseForm form={form} layout="vertical" name="CreateForm" onFinish={handleSubmit}>
        <BaseForm.Item name="title" label="Title" rules={[{ required: true, message: t('common.requiredField') }]}>
          <Input />
        </BaseForm.Item>
        <BaseForm.Item
          name="files"
          label="Form Icon"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          initialValue={[]}
          rules={[{ required: false }]}
        >
          <Upload accept="image/*" maxCount={1} customRequest={dummyRequest} listType="picture">
            <Button type="default" icon={<UploadOutlined />}>
              {t('forms.validationFormLabels.clickToUpload')}
            </Button>
          </Upload>
        </BaseForm.Item>
        <S.HintText>{t('thumbnailUpload.uploadHint')}</S.HintText>
      </BaseForm>
    </Modal>
  );
};
